export default "__VITE_ASSET__DSAPwOK4__"